export default __webpack_public_path__ + "static/media/9.a0ef7c8d.jpg";